import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, PackageIcon, MessageSquareIcon, UsersIcon, FileTextIcon, SettingsIcon, HelpCircleIcon } from 'lucide-react';
export function Sidebar() {
  const location = useLocation();
  // Mock authentication state
  const user = {
    role: 'buyer'
  }; // or "supplier"
  const buyerLinks = [{
    name: 'Dashboard',
    href: '/dashboard',
    icon: LayoutDashboardIcon
  }, {
    name: 'Browse Products',
    href: '/products',
    icon: PackageIcon
  }, {
    name: 'My Orders',
    href: '/orders',
    icon: FileTextIcon
  }, {
    name: 'Messages',
    href: '/messages',
    icon: MessageSquareIcon
  }, {
    name: 'Suppliers',
    href: '/suppliers',
    icon: UsersIcon
  }];
  const supplierLinks = [{
    name: 'Dashboard',
    href: '/dashboard',
    icon: LayoutDashboardIcon
  }, {
    name: 'My Products',
    href: '/products',
    icon: PackageIcon
  }, {
    name: 'Orders',
    href: '/orders',
    icon: FileTextIcon
  }, {
    name: 'Messages',
    href: '/messages',
    icon: MessageSquareIcon
  }, {
    name: 'Customers',
    href: '/customers',
    icon: UsersIcon
  }];
  const links = user.role === 'buyer' ? buyerLinks : supplierLinks;
  return <div className="hidden md:flex flex-col w-64 bg-white border-r border-gray-200" data-id="element-102">
      <div className="p-4" data-id="element-103">
        <div className="p-2 bg-red-50 rounded-lg" data-id="element-104">
          <div className="font-medium text-red-800 capitalize" data-id="element-105">
            {user.role} Portal
          </div>
        </div>
      </div>
      <nav className="flex-1 px-2 py-4 space-y-1" data-id="element-106">
        {links.map(link => {
        const Icon = link.icon;
        return <Link key={link.name} to={link.href} className={`${location.pathname === link.href ? 'bg-red-50 text-red-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'} group flex items-center px-3 py-2 text-sm font-medium rounded-md`} data-id="element-107">
              <Icon className={`${location.pathname === link.href ? 'text-red-500' : 'text-gray-400 group-hover:text-gray-500'} mr-3 h-5 w-5`} data-id="element-108" />
              {link.name}
            </Link>;
      })}
      </nav>
      <div className="p-4 border-t border-gray-200" data-id="element-109">
        <nav className="space-y-1" data-id="element-110">
          <Link to="/settings" className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md" data-id="element-111">
            <SettingsIcon className="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5" data-id="element-112" />
            Settings
          </Link>
          <Link to="/help" className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md" data-id="element-113">
            <HelpCircleIcon className="text-gray-400 group-hover:text-gray-500 mr-3 h-5 w-5" data-id="element-114" />
            Help & Support
          </Link>
        </nav>
      </div>
    </div>;
}